
function About() {
  return (
    <div>
      <h1>i`m nadeen shaik</h1>
    </div>
  );
}
export default About;
